import { LanguageCode } from "./enums";

export const LANGUAGE_MOMENT_LOCALE_MAP = {
  [LanguageCode.EN_US]: "en",
  [LanguageCode.PT_BR]: "pt-br",
} as const;
